<template>
  <ul class="pagination" :class="paginationClass">
    <li
      class="page-item prev-page"
      :class="{ disabled: value === 1, 'no-arrows': noArrows }"
    >
      <a class="page-link" aria-label="Previous" @click="prevPage(weeksRange[4].weekNumber, weeksRange[4].year)">
        <i class="fas fa-angle-left"></i>
      </a>
    </li>
    <li
      class="page-item"
      v-for="item in weeksRange"
      :key="item.weekNumber"
      :class="{ active: value === item.weekNumber }"
    >
      <a class="page-link" @click="changePage(item.weekNumber, item.year)">{{ item.weekNumber }}</a>
    </li>
    <li
      class="page-item page-pre next-page"
      :class="{ disabled: value === totalPages, 'no-arrows': noArrows }"
    >
      <a class="page-link" aria-label="Next" @click="nextPage(weeksRange[weeksRange.length -5].weekNumber, weeksRange[weeksRange.length -5].year)">
        <i class="fas fa-angle-right"></i>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  name: "pagination",
  props: {
    type: {
      type: String,
      default: "primary",
      validator: value => {
        return [
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info",
          "rose"
        ].includes(value);
      }
    },
    noArrows: Boolean,
    pageCount: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    },
    year: {
      type: Number,
    },
    week: {
      type: Number,
    },
    retoucher: {
      type: String,
      default: ''
    }
  },
  computed: {
    paginationClass() {
      //return `pagination-${this.type}`;
      return `pagination-success`;
    },
    totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage() {
      if (this.value >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        const newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage() {
      if (this.value >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        const newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    },
    weeksRange(){
      return this.getWeeksArray(this.weeksLeft,this.weeksRight, this.selectedWeek, this.selectedYear);
    }
  },
  data() {
    return {
      defaultPagesToDisplay: 11,
      weeksLeft: -5,
      weeksRight: 5,
      selectedWeek: null,
      selectedYear: null,
    };
  },
  methods: {
    getWeekRange(weekNumber, year) {
      const startDate = new Date(year, 0, 1);
      const startWeekFirstDay = new Date(startDate.getTime());
      startWeekFirstDay.setDate(startDate.getDate() + (weekNumber - 1) * 7);

      const endDate = new Date(year, 0, 1);
      const endWeekLastDay = new Date(endDate.getTime());
      endWeekLastDay.setDate(endDate.getDate() + (weekNumber - 1) * 7 + 6);

      return [startWeekFirstDay, endWeekLastDay];
    },
    getNumberOfWeeksInYear(year) {
      const firstDayOfYear = new Date(year, 0, 1);
      const lastDayOfYear = new Date(year, 11, 31);

      // Check if the last week's Thursday falls into the next year
      if (firstDayOfYear.getDay() <= 4) {
        firstDayOfYear.setDate(firstDayOfYear.getDate() + (4 - firstDayOfYear.getDay()));
      } else {
        firstDayOfYear.setDate(firstDayOfYear.getDate() + (11 - firstDayOfYear.getDay()));
      }

      if (lastDayOfYear.getDay() <= 4) {
        lastDayOfYear.setDate(lastDayOfYear.getDate() - (lastDayOfYear.getDay() + 3));
      } else {
        lastDayOfYear.setDate(lastDayOfYear.getDate() + (10 - lastDayOfYear.getDay()));
      }

      const daysBetween = Math.floor((lastDayOfYear - firstDayOfYear) / (24 * 60 * 60 * 1000)) + 1;

      return Math.ceil(daysBetween / 7);
    },
    getCurrentWeek() {
      if(this.selectedWeek && this.selectedYear){
        return { weekNumber: this.selectedWeek, year: this.selectedYear };
      }
      const now = new Date();
      let currentYear = now.getFullYear();
      let currentWeek = this.getISOWeek(now);
      //console.log(this.value,this.week,this.year);
      if(currentWeek != this.value) currentWeek = this.value;
      if(currentYear != this.year) currentYear = this.year;
      return { weekNumber: currentWeek, year: currentYear };
    },
    getISOWeek(date) {
      const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
      const dayOfYear = Math.floor((date - firstDayOfYear) / (24 * 60 * 60 * 1000));
      const weekNumber = Math.ceil((date.getDay() + 1 + dayOfYear) / 7);
      return weekNumber;
    },
    getWeeksArray(weeksLeft, weeksRight, selectedWeek, selectedYear) {
      const currentWeekInfo = this.getCurrentWeek();
      const weeksArray = [];

      for (let i = weeksLeft; i <= weeksRight; i++) {
        const { weekNumber, year } = currentWeekInfo;
        const adjustedWeek = weekNumber + i ;

        // Handle year change for the 1st and last week of the year
        const adjustedYear = year + Math.floor((adjustedWeek - 1) / 52);
        const normalizedWeek = ((adjustedWeek - 1) % 52) + 1 + (adjustedWeek <= 0 ? this.getNumberOfWeeksInYear(year): 0 );

        const [startDate, endDate] = this.getWeekRange(normalizedWeek, adjustedYear);
        weeksArray.push({
          weekNumber: normalizedWeek,
          year: adjustedYear,
          startDate,
          endDate,
        });
      }
      //console.log(weeksArray);
      return weeksArray;
    },

    changePage(week, year) {
      this.selectedWeek = week;
      this.selectedYear = year;
      this.$emit("input-child", {page:week, year: year});
    },
    nextPage(week, year) {
      this.selectedWeek = week;
      this.selectedYear = year;
      this.$emit("input-child", {page:week, year: year});
    },
    prevPage(week, year) {
      this.selectedWeek = week;
      this.selectedYear = year;
      this.$emit("input-child", {page:week, year: year});
    }
  },
  watch: {
    perPage() {
      this.$emit("input", 1);
    },
    total() {
      this.$emit("input", 1);
    },
    retoucher:{
      immediate: false,
      handler(newValue, oldValue) {
        // Handle changes in combinedValues
        this.$nextTick(() => {
          if(this.year > 0 && this.week > 0){
            this.selectedYear = this.year;
            this.selectedWeek = this.week;
          }
        });
      }
    }
  }
};
</script>
